import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _ADD_LABEL_BY_PRODUCT, _ADD_ICON_BY_PRODUCT_;

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { PRODUCT_TYPES } from '@nerdwallet/marketplace/constants';
import analyticsLib from '@nerdwallet/analytics';
import { Impression, ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { ElementImpression, ElementInteraction } from '@nerdwallet/nw-client-lib/tracking';
import AddCard from '../images/addCard';
import { EVENT_TYPES, ENTITY_NAME, ACTION, INTERACTION_TYPE } from '../../lib/analytics-constants';
import AddLoan from '../images/addLoan';
import styles from '../comparison-grid.module.less';
import { STATIC_PERSONAL_LOANS } from '../../lib/product-constants';
var ADD_LABEL_BY_PRODUCT_TYPE = (_ADD_LABEL_BY_PRODUCT = {}, _defineProperty(_ADD_LABEL_BY_PRODUCT, PRODUCT_TYPES.PERSONAL_LOANS, 'Add a loan'), _defineProperty(_ADD_LABEL_BY_PRODUCT, STATIC_PERSONAL_LOANS, 'Add a lender'), _defineProperty(_ADD_LABEL_BY_PRODUCT, PRODUCT_TYPES.CREDIT_CARDS, 'Add a card'), _defineProperty(_ADD_LABEL_BY_PRODUCT, PRODUCT_TYPES.MORTGAGES, 'Add a lender'), _defineProperty(_ADD_LABEL_BY_PRODUCT, "DEFAULT", 'Add a lender'), _ADD_LABEL_BY_PRODUCT);
var ADD_ICON_BY_PRODUCT_TYPE = (_ADD_ICON_BY_PRODUCT_ = {}, _defineProperty(_ADD_ICON_BY_PRODUCT_, PRODUCT_TYPES.PERSONAL_LOANS, AddLoan), _defineProperty(_ADD_ICON_BY_PRODUCT_, STATIC_PERSONAL_LOANS, AddLoan), _defineProperty(_ADD_ICON_BY_PRODUCT_, PRODUCT_TYPES.CREDIT_CARDS, AddCard), _defineProperty(_ADD_ICON_BY_PRODUCT_, PRODUCT_TYPES.MORTGAGES, AddLoan), _defineProperty(_ADD_ICON_BY_PRODUCT_, "DEFAULT", AddLoan), _ADD_ICON_BY_PRODUCT_);
/* Add new entity to compare */

export var AddEntityToCompare = function AddEntityToCompare(_ref) {
  var canAdd = _ref.canAdd,
      productType = _ref.productType,
      tabName = _ref.tabName,
      tabPosition = _ref.tabPosition,
      updateShouldShowSearch = _ref.updateShouldShowSearch,
      className = _ref.className,
      shouldAddEntityRender = _ref.shouldAddEntityRender,
      isCompareGridEmpty = _ref.isCompareGridEmpty;

  // will show entity search
  var addNewEntityHandler = function addNewEntityHandler(impressionId) {
    analyticsLib.track(EVENT_TYPES.ELEMENT_INTERACTED, {
      action: ACTION.SELECT,
      entity_name: ENTITY_NAME.COMPARISON_GRID_ADD_ENTITY,
      interaction_type: INTERACTION_TYPE.PRESS,
      impression_id: impressionId
    });
    updateShouldShowSearch(true);
  };

  var thClassName = classNames([className, shouldAddEntityRender && styles.compareGridCellWithAddEntity || styles.compareGridCellWidth, styles.addNewEntityContainer, styles.blankAddEntityCell]);
  var impressionPayload = {
    section_name: tabName,
    section_position: tabPosition
  };
  var AddIcon = ADD_ICON_BY_PRODUCT_TYPE[productType] || ADD_ICON_BY_PRODUCT_TYPE.DEFAULT;
  return !canAdd ? /*#__PURE__*/React.createElement("th", {
    className: thClassName
  }) : /*#__PURE__*/React.createElement(Impression, {
    component: "th",
    className: thClassName,
    entityName: ENTITY_NAME.COMPARISON_GRID_ADD_ENTITY,
    eventType: EVENT_TYPES.ELEMENT_IMPRESSION,
    payload: impressionPayload
  }, /*#__PURE__*/React.createElement(ElementImpression, {
    id: ENTITY_NAME.COMPARISON_GRID_ADD_ENTITY,
    elementName: ENTITY_NAME.COMPARISON_GRID_ADD_ENTITY,
    sectionCategory: tabName,
    sectionPosition: tabPosition
  }, /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (impressionContext) {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(_defineProperty({}, styles.addNewEntity__button, !isCompareGridEmpty))
    }, /*#__PURE__*/React.createElement(ElementInteraction, {
      elementCategory: "select",
      elementName: ENTITY_NAME.COMPARISON_GRID_ADD_ENTITY,
      id: "".concat(ENTITY_NAME.COMPARISON_GRID_ADD_ENTITY, "_select"),
      type: "CLICK"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: styles.addNewEntity__icon,
      onClick: function onClick() {
        return addNewEntityHandler(impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId);
      }
    }, /*#__PURE__*/React.createElement(AddIcon, null))), /*#__PURE__*/React.createElement("div", {
      className: styles.addNewEntity__title
    }, ADD_LABEL_BY_PRODUCT_TYPE[productType] || ADD_LABEL_BY_PRODUCT_TYPE.DEFAULT));
  })));
};
AddEntityToCompare.propTypes = {
  /**  Optional boolean to enable user to add entities within the compare panel by using MarketplaceSearch,
   *  defaulted to false.
   */
  canAdd: PropTypes.bool,

  /**
   * Sets <shouldShowSearch> to display search component or not
   */
  updateShouldShowSearch: PropTypes.func,

  /**
   * The name of the tab thats in view.
   */
  tabName: PropTypes.string.isRequired,

  /**
   * The active tab position thats in view.
   */
  tabPosition: PropTypes.number.isRequired,

  /**
   * Boolean if add entity button should render or not
   */
  shouldAddEntityRender: PropTypes.bool,
  className: PropTypes.shape({}),

  /**
   * Boolean if no entities are pre-selected to compare
   */
  isCompareGridEmpty: PropTypes.bool,
  productType: PropTypes.string.isRequired
};
AddEntityToCompare.defaultProps = {
  canAdd: false,
  isCompareGridEmpty: false
};